import type { SupportTranslations } from './types'

export const urTranslations: SupportTranslations = {
  title: 'سپورٹ ٹکٹس',
  subtitle: 'کسٹمر اور اندرونی سپورٹ درخواستوں کا انتظام',
  newTicket: 'نیا ٹکٹ',
  getHelp: 'مدد حاصل کریں',
  submitTicket: 'ٹکٹ جمع کرائیں',
  submit: 'ٹکٹ جمع کرائیں',

  statusOpen: 'کھلا',
  statusInProgress: 'جاری',
  statusWaiting: 'رپورٹر کا انتظار',
  statusResolved: 'حل ہو گیا',
  statusClosed: 'بند',

  priorityLow: 'کم',
  priorityMedium: 'درمیانہ',
  priorityHigh: 'زیادہ',
  priorityUrgent: 'فوری',

  channelCustomer: 'کسٹمر',
  channelInternal: 'اندرونی',
  allChannels: 'تمام چینلز',
  filterChannel: 'چینل',

  categoryOrder: 'آرڈر کا مسئلہ',
  categoryDelivery: 'ڈیلیوری کا مسئلہ',
  categoryPayment: 'ادائیگی کا مسئلہ',
  categoryAccount: 'اکاؤنٹ کا مسئلہ',
  categoryBug: 'پلیٹ فارم بگ',
  categoryFeature: 'فیچر کی درخواست',
  categoryGeneral: 'عام',
  categoryOther: 'دیگر',

  statsOpen: 'کھلے',
  statsInProgress: 'جاری',
  statsResolved: 'حل شدہ',
  statsTotal: 'کل',

  colTicket: 'ٹکٹ نمبر',
  colSubject: 'موضوع',
  colChannel: 'چینل',
  colCategory: 'زمرہ',
  colPriority: 'ترجیح',
  colStatus: 'حالت',
  colCreated: 'تاریخ',

  fieldSubject: 'موضوع',
  fieldCategory: 'زمرہ',
  fieldPriority: 'ترجیح',
  fieldDescription: 'تفصیل',
  fieldEmail: 'ای میل',
  fieldPhone: 'فون نمبر',
  fieldAttachments: 'تصاویر',
  subjectPlaceholder: 'اپنے مسئلے کا مختصر خلاصہ',
  selectCategory: 'زمرہ منتخب کریں',
  descriptionPlaceholder: 'اپنے مسئلے کی تفصیل بیان کریں...',
  emailPlaceholder: 'email@example.com',
  phonePlaceholder: '٩٦٦+ 5X XXX XXXX',
  attachmentsHint: 'زیادہ سے زیادہ 5 تصاویر اپ لوڈ کریں (ہر ایک 10MB تک)',
  attachmentsRequired: 'کم از کم ایک تصویر لازمی ہے',
  removePhoto: 'تصویر ہٹائیں',
  addPhoto: 'تصاویر شامل کرنے کے لیے کلک کریں',
  addPhotoFormats: 'JPG، PNG، WEBP، GIF',
  fileTooLarge: 'فائلز 10MB سے کم ہونی چاہئیں',
  photo: 'تصویر',
  photos: 'تصاویر',
  submittingAs: 'اس نام سے جمع کرایا جا رہا ہے',
  submitting: 'جمع کرایا جا رہا ہے...',

  searchPlaceholder: 'ٹکٹس تلاش کریں...',
  filterByStatus: 'حالت کے مطابق فلٹر',
  selectStatus: 'حالت منتخب کریں',
  noTickets: 'کوئی سپورٹ ٹکٹ نہیں ملا',

  tabOverview: 'جائزہ',
  tabNotes: 'نوٹس',
  assignedTo: 'تفویض شدہ',
  unassigned: 'غیر تفویض شدہ',
  tenant: 'کرایہ دار',
  resolvedAt: 'حل کی تاریخ',
  updateStatus: 'حالت اپ ڈیٹ کریں',

  noNotes: 'ابھی تک کوئی نوٹ نہیں',
  addNote: 'نوٹ شامل کریں',
  notePlaceholder: 'نوٹ شامل کریں...',

  createSuccess: 'سپورٹ ٹکٹ کامیابی سے بنایا گیا',
  updateSuccess: 'سپورٹ ٹکٹ کامیابی سے اپ ڈیٹ ہو گیا',
  createError: 'سپورٹ ٹکٹ بنانے میں ناکامی',
  updating: 'اپ ڈیٹ ہو رہا ہے...',
  customerSupportTitle: 'سپورٹ',
  customerSupportSubtitle: 'اپنے آرڈرز، ڈیلیوریز اور اکاؤنٹ کے لیے مدد حاصل کریں',
  myTickets: 'میرے ٹکٹس',
  noMyTickets: 'آپ کے پاس ابھی تک کوئی سپورٹ ٹکٹ نہیں ہے',
}
